import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import TableCell, { TableCellProps } from "@material-ui/core/TableCell";
import Cached from "@material-ui/icons/Cached";
import classNames from "classnames";
import React from "react";

import Image from "../../icons/Image";

export const AVATAR_MARGIN = 32;

const useStyles = makeStyles(
  theme => ({
    alignRight: {
      justifyContent: "flex-end"
    },
    avatar: {
      background: "none",
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 2,
      color: "#bdbdbd",
      display: "inline-flex",
      padding: theme.spacing(0.5)
    },
    avatarfd: {
      display: "none",
      width: 450,
      top: "20%",
      right: 0,
      position: "fixed",
      zIndex: 9999,
      border: "10px solid #fff"
    },
    children: {
      alignSelf: "center",
      marginLeft: theme.spacing(2),
      width: "100%"
    },
    content: {
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      position: "relative"
    },
    root: {
      "&:not(first-child)": {
        paddingLeft: 0
      },
      paddingRight: theme.spacing(3),
      width: "auto"
    },
    avatarBox: {
      position: "relative",
      minWidht: 45,
      minHeight: 45,
      "&:hover $avatarfd": {
        display: "block"
      }
    }
  }),
  { name: "TableCellAvatar" }
);

interface TableCellAvatarProps extends TableCellProps {
  className?: string;
  thumbnail?: string;
  alignRight?: boolean;
  avatarProps?: string;
  children?: React.ReactNode | React.ReactNodeArray;
}

const TableCellAvatar: React.FC<TableCellAvatarProps> = props => {
  const {
    children,
    className,
    alignRight,
    thumbnail,
    avatarProps,
    ...rest
  } = props;

  const classes = useStyles(props);
  return (
    <TableCell className={classNames(classes.root, className)} {...rest}>
      <div
        className={classNames(classes.content, {
          [classes.alignRight]: alignRight
        })}
      >
        <div className={classes.avatarBox}>
          {thumbnail === undefined ? (
            <Avatar className={classNames(classes.avatar, avatarProps)}>
              <Cached color="primary" />
            </Avatar>
          ) : thumbnail === null ? (
            <Avatar className={classNames(classes.avatar, avatarProps)}>
              <Image color="primary" />
            </Avatar>
          ) : thumbnail.split(".")[thumbnail.split(".").length - 1] ===
            "mp4" ? (
            <Avatar className={classNames(classes.avatar, avatarProps)}>
              <video style={{ width: "100%", height: "100%" }}>
                <source src={thumbnail}></source>
              </video>
            </Avatar>
          ) : (
            <>
              <Avatar
                className={classNames(classes.avatar, avatarProps)}
                src={thumbnail}
              ></Avatar>
              <img src={thumbnail} className={classNames(classes.avatarfd)} />
            </>
          )}
        </div>
        {children && <div className={classes.children}>{children}</div>}
      </div>
    </TableCell>
  );
};
TableCellAvatar.displayName = "TableCellAvatar";
export default TableCellAvatar;
